import React from 'react';
import { Share, SvgIconComponent } from '@mui/icons-material';
import { IconButton } from '@mui/material';


type ShareButtonProps = ShareData & {
    icon?: SvgIconComponent,
    size?: 'sm' | 'md',
}
const ShareButton = ({icon: Icon = Share, size = 'md', ...data}: ShareButtonProps) => {
    const click = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigator.share(data);
    };

    if (size === 'sm')
        return <Icon
            fontSize="small"
            onClick={click}
            sx={{
                color: 'text.disabled',
                cursor: 'pointer',
                '&:hover': {
                    color: 'text.primary',
                },
            }}
        />

    return (
        <IconButton
            aria-label="share"
            onClick={click}
        >
            <Icon/>
        </IconButton>
    );
};

export default ShareButton;
